import DeleteIcon from '@mui/icons-material/Delete';
import DragIndicatorIcon from '@mui/icons-material/DragIndicator';
import IconButton from '@mui/material/IconButton';
import TextField from '@mui/material/TextField';
import CardBox from '@src/App/Components/Cards/CardBox/CardBox';
import React, { useEffect, useState } from 'react';

import styles from './RootDashboardWidget.module.css';

interface RootDashboardWidgetProps {
    id: string;
    title: string;
    isEditing: boolean;
    overrideCardDesign?: boolean;
    onDelete: (id: string) => void;
    onTitleChange: (id: string, title: string) => void;
    children: React.ReactNode;
}
export const RootDashboardWidget: React.FC<RootDashboardWidgetProps> = ({
    id,
    title,
    isEditing,
    overrideCardDesign,
    onDelete,
    onTitleChange,
    children,
}) => {
    const [editTitle, setEditTitle] = useState(title);
    useEffect(() => setEditTitle(title), [title]);
    const handleBlur = () => {
        if (editTitle !== title) onTitleChange(id, editTitle);
    };
    if (!isEditing && overrideCardDesign) {
        return (
            <div className={styles.dashboardWidget}>
                <div className={styles.dashboardWidgetContent}>{children}</div>
            </div>
        );
    }

    return (
        <CardBox
            title={
                isEditing ? (
                    <TextField
                        variant="standard"
                        value={editTitle}
                        onChange={(e) => setEditTitle(e.target.value)}
                        onBlur={handleBlur}
                        size="small"
                        style={{ width: '100%' }}
                    />
                ) : (
                    title
                )
            }
            leftButtons={
                isEditing ? (
                    <DragIndicatorIcon className="drag-handle" style={{ cursor: 'grab', marginRight: 5 }} />
                ) : undefined
            }
            rightButtons={
                isEditing ? (
                    <IconButton onClick={() => onDelete(id)}>
                        <DeleteIcon />{' '}
                    </IconButton>
                ) : undefined
            }
            className={styles.dashboardWidget}
        >
            <div className={styles.dashboardWidgetContent}>{children}</div>
        </CardBox>
    );
};
